const Actions = {
  SET_FILTER: "SET_FILTER",
  GET_FILTER: "GET_FILTER",
  CLEAR_FILTER: "CLEAR_FILTER",
  REMOVE_FILTER:"REMOVE_FILTER"
};

export default Actions;
